import ReactGA4 from 'react-ga4';
export class GoogleAnalytics4 {
    constructor(siteId) {
        this.siteId = siteId;
        this.pageView = (page) => {
            if (this.siteId) {
                ReactGA4.set({ page });
                ReactGA4.send(page);
            }
        };
        this.event = (event) => {
            if (this.siteId) {
                ReactGA4.event(event);
            }
        };
        if (siteId) {
            ReactGA4.initialize(siteId);
        }
    }
}
//# sourceMappingURL=GoogleAnalytics4.js.map